<template>
    <div
        id="lt-yantr"
        class="home-value">
        <div
            v-if="!addressFound"
            class="address-block home-value-background-img">
            <div class="search-block">
                <div class="title-block">
                    <h2 class="search-title">
                        How much is my home worth?
                    </h2>
                </div>
                <div class="address-input">
                    <label
                        v-show="!addressFound && showInvalidAddressError"
                        class="error-mgs">
                        <span>Oops!</span> We didn't find info for that address. Please try your search again.
                    </label>
                    <div class="input-group">
                        <address-input
                            ref="autocomplete"
                            v-model="streetAddress"
                            name="streetAddress"
                            class="form-control"
                            @placechanged="getAddressData"
                            @check-valid-address="validAddress"
                            @enter="getStreetAddressInfo()"
                        />
                        <span class="input-group-addon">
                            <button
                                class="btn btn-orange"
                                type="button"
                                @click="getStreetAddressInfo()">View Estimated Value</button>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="addressFound"
            class="address-block">
            <google-map
                name="homeValue"
                :position="latLonData"
            />
            <div
                v-if="addressFound"
                class="home-value-map-img hidden-xs">
                <img :src="googleAddressURL" />
            </div>

            <div class="search-block">
                <div class="title-block">
                    <h2 class="location">
                        {{ streetAddressObj.streetNumber }} {{ streetAddressObj.streetName }}<span> {{ streetAddressObj.city }}, {{ streetAddressObj.state }}, {{ streetAddressObj.zipCode }} </span>
                    </h2>
                </div>
                <div class="address-input">
                    <div
                        v-if="homeValueFound"
                        class="home-value-calc">
                        <h1>${{ homeValuationData.valuation.value | currency }}</h1>
                        <ul>
                            <li>
                                <h3
                                    v-if="homeValuationData.valuation.changeInValue > 0"
                                    class="green-text">
                                    +${{ homeValuationData.valuation.changeInValue | currency }}
                                </h3>
                                <h3
                                    v-if="homeValuationData.valuation.changeInValue < 0"
                                    class="red-text">
                                    -${{ Math.abs(homeValuationData.valuation.changeInValue) | currency }}
                                </h3>
                                <label>Low ${{ homeValuationData.valuation.valueLow | currency }} / High ${{ homeValuationData.valuation.valueHigh | currency }}</label>
                                <label>Last Sold {{ homeValuationData.details.lastSoldDate | date }} For ${{ homeValuationData.details.lastSoldAmount | currency }}</label>
                            </li>
                            <li>
                                <h3 class="gray-text">
                                    {{ homeValuationData.details.bedrooms }} Bed {{ homeValuationData.details.bathrooms }} Bath
                                </h3>
                                <label>{{ homeValuationData.details.heatedSquareFootage | currency }} Sq. Ft. - ${{ homeValuationData.valuation.value / homeValuationData.details.heatedSquareFootage | currency }}/Sq. Ft.</label>
                                <label>{{ homeValuationData.details.lotSquareFootage | currency }} Sq. Ft. Lot Size</label>
                            </li>
                        </ul>

                        <div class="text-center">
                            <a
                                href="/redirect/offers?id=wp-home-equity"
                                class="btn btn-orange"><i class="hidden-xs">View </i>Home Equity Offers</a>
                        </div>
                    </div>
                    <div
                        v-if="!homeValueFound"
                        class="home-value-calc">
                        <div v-show="ShowLoading">
                            <transition name="fade">
                                <div class="loader">
                                    <img
                                        alt="lt-loader"
                                        width="61"
                                        height="60"
                                        src="data:image/png;base64,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"
                                    />
                                </div>
                            </transition>
                        </div>
                        <div v-show="!ShowLoading">
                            <div><span class="home-icon"></span></div>
                            <h1>No Home Value Found</h1>
                            <h3>Our search did not retrieve a home value for this address.</h3>
                            <h3>Use the field below to search another address</h3>
                        </div>
                    </div>
                    <h3
                        v-if="addressFound"
                        class="search-address">
                        Search another address
                    </h3>
                    <div class="input-group">
                        <address-input
                            ref="autocomplete"
                            v-model="streetAddress"
                            name="streetAddress"
                            class="form-control"
                            @placechanged="getAddressData"
                            @check-valid-address="validAddress"
                            @enter="getStreetAddressInfo()"
                        />
                        <span class="input-group-addon">
                            <button
                                class="btn btn-orange"
                                type="button"
                                @click="getStreetAddressInfo()">View Estimated Value</button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import GetLatLong from '~/services/google-maps-api';
    import GoogleMap from './components/google-map.vue';
    import AddressInput from './components/address-input.vue';
    import HomeValuationService from '~/services/home-valuation';

    export default {
        components: {
            GoogleMap,
            AddressInput,
        },
        filters: {
            date(date) {
                const dateObj = new Date(date);
                return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
            },
            currency(val) {
                return Accounting.formatNumber(val);
            },
        },
        mixins: [],
        props: {

        },
        data() {
            return {
                latLonData: {},
                streetAddress: '',
                streetAddressObj: {},
                googleAddressURL: '',
                homeValuationData: {},
                addressFound: false,
                addressValidatedFromApi: false,
                homeValueFound: false,
                showInvalidAddressError: false,
                streetAddressFromComponent: null,
                ShowLoading: true,
            };
        },
        methods: {
            getStreetAddressInfo() {
                this.streetAddress = '';
                this.addressFound = this.addressValidatedFromApi;
                this.streetAddressObj = this.streetAddressFromComponent;
                this.showInvalidAddressError = false;
                if (!this.addressFound) {
                    this.showInvalidAddressError = true;
                    return;
                }
                const addressString = `${this.streetAddressObj.streetNumber} ${this.streetAddressObj.streetName}, ${this.streetAddressObj.city}, ${this.streetAddressObj.state}, ${this.streetAddressObj.zipCode}`;
                this.googleAddressURL = `https://maps.googleapis.com/maps/api/streetview?size=640x480&location=${encodeURIComponent(addressString)}&key=AIzaSyAyfusPC-K163uxN11DnZwqnBpgj7CKaoY`;
                GetLatLong(addressString).then((data) => {
                    if (data.success) {
                        this.latLonData = data.location;
                    }
                });
                HomeValuationService.getHomeValuationData(addressString).then((data) => {
                    if (data.address !== undefined) {
                        this.homeValuationData = data;
                        this.homeValuationData.valuation.changeInValue = this.homeValuationData.valuation.value - this.homeValuationData.details.lastSoldAmount;
                        this.homeValueFound = true;
                    } else {
                        this.homeValueFound = false;
                        this.ShowLoading = false;
                    }
                    setTimeout(() => {
                        this.ShowLoading = false;
                    }, 2500);
                }, () => {
                    this.homeValueFound = false;
                    this.ShowLoading = false;
                }).catch((e) => {
                    console.warn(e);
                    this.homeValueFound = false;
                    this.ShowLoading = false;
                });
            },
            getAddressData(addressData) {
                this.streetAddressFromComponent = {
                    streetNumber: addressData.street_number,
                    streetName: addressData.route,
                    city: addressData.locality,
                    state: addressData.administrative_area_level_1,
                    zipCode: addressData.postal_code,
                };
            },
            validAddress(value) {
                this.addressValidatedFromApi = value;
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
